import React from 'react';

const ChartIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.63647 14.3258L8.96432 9.75992C9.31335 9.28104 9.99991 9.20901 10.4407 9.60502L13.1066 11.9999C13.5574 12.4048 14.2619 12.319 14.6023 11.8176L19.3865 4.76904"
      stroke="#555B67"
      strokeWidth="2"
    />
    <path
      d="M1.83325 3.2085V16.4213C1.83325 17.5258 2.72868 18.4213 3.83325 18.4213H20.1666"
      stroke="#555B67"
      strokeWidth="2"
    />
  </svg>
);

export default ChartIcon;
